export interface UVRange {
  startU: number;
  endU: number;
  startV: number;
  endV: number;
}

export interface Achievement {
  range: UVRange;
  runeNodeName: string;
}

export const achievements: { [key: string]: Achievement } = {
  aludelv1: {
    range: {
      startU: 0.8,
      endU: 1,
      startV: 0.83,
      endV: 1
    },
    runeNodeName: 'Runes_1_23'
  },
  fullMultiplier1: {
    range: {
      startU: 0.2,
      endU: 0.4,
      startV: 0,
      endV: 0.17
    },
    runeNodeName: 'Runes_1_27'
  },
  fullMultiplier2: {
    range: {
      startU: 0.2,
      endU: 0.38,
      startV: 0.32,
      endV: 0.5
    },
    runeNodeName: 'Runes_1_17'
  },
  rewardPrograms1: {
    range: {
      startU: 0.8,
      endU: 1,
      startV: 0.17,
      endV: 0.34
    },
    runeNodeName: 'Runes_1_13'
  }
};
